import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin, ShieldCheck } from 'lucide-react';
import ConsentManager from './ConsentManager';
import { openDPDPManage } from './DPDPConsentBoot';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [consentOpen, setConsentOpen] = useState(false);

  const openConsent = (e) => {
    e.preventDefault();
    if (!openDPDPManage()) {
      setConsentOpen(true);
    }
  };

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Blog', path: '/blog' },
      { name: 'Privacy Policy', path: '/privacy-policy' }
    ],
    services: [
      { name: 'Cybersecurity', path: '/services/cybersecurity' },
      { name: 'System Integration', path: '/services/system-integration' },
      { name: 'Network Services', path: '/services/network-services' }
    ],
    solutions: [
      { name: 'SIEM & SOAR', path: '/services/cybersecurity' },
      { name: 'Managed SOC', path: '/services/cybersecurity' },
      { name: 'Cloud Services', path: '/services/system-integration' },
      { name: 'SD-WAN', path: '/services/network-services' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-2xl font-bold mb-4">
              Sanghvi <span className="text-blue-500">Infotech</span>
            </h3>
            <p className="text-gray-400 mb-6">
              Empowering businesses with innovative and secure ICT solutions for over two decades.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="hover:text-blue-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="hover:text-blue-500 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-blue-500 flex-shrink-0 mt-1" />
                <span className="text-sm">
                  907, Pinnacle Business Park,<br />
                  Corporate Road, Prahlad Nagar,<br />
                  Ahmedabad, Gujarat - 380015
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-blue-500 flex-shrink-0" />
                <span className="text-sm">+91 98258 01301</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-blue-500 flex-shrink-0" />
                <span className="text-sm">info@sanghviinfo.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Sanghvi Infotech Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0 items-center flex-wrap">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-500 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-blue-500 text-sm transition-colors">
                Terms of Service
              </Link>
              <button
                data-testid="footer-manage-consent"
                onClick={openConsent}
                className="text-gray-400 hover:text-cyan-400 text-sm transition-colors flex items-center gap-1.5"
              >
                <ShieldCheck className="h-3.5 w-3.5" />
                Manage My Consent
              </button>
            </div>
          </div>
        </div>
      </div>
      <ConsentManager open={consentOpen} onOpenChange={setConsentOpen} />
    </footer>
  );
};

export default Footer;